export const formatWholeNumber = (value: number | null): string => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '';
  return Number.isInteger(value) ? String(value) : '';
};

export const formatStackedBarTooltipValue = (value: number | null): string | null => {
  if (typeof value !== 'number' || !Number.isFinite(value) || value === 0) return null;
  return formatWholeNumber(value);
};
